import React from 'react';
import noop from 'lodash/noop';
import PropTypes from 'prop-types';

/**
 * Wraps children in a isolated context that shadows the parent Form's
 * registration and change-notification functions with no-ops. Any Fieldtable
 * or Field nested inside will not register with the ancestor Form, will not
 * mark it as "edited", and will not contribute its value to form submissions.
 */
export default class IsolatedFields extends React.Component {
  static childContextTypes = {
    registerField: PropTypes.func,
    unregisterField: PropTypes.func,
    onChangeField: PropTypes.func,
    setFormValue: PropTypes.func,
    subscribeChange: PropTypes.func,
    unsubscribeChange: PropTypes.func,
  };

  static propTypes = {
    children: PropTypes.node,
  };

  getChildContext() {
    return {
      registerField: noop,
      unregisterField: noop,
      onChangeField: noop,
      setFormValue: noop,
      subscribeChange: noop,
      unsubscribeChange: noop,
    };
  }

  render() {
    return this.props.children;
  }
}
